import { render, staticRenderFns } from "./AddReply.vue?vue&type=template&id=c55b4128&"
import script from "./AddReply.vue?vue&type=script&lang=js&"
export * from "./AddReply.vue?vue&type=script&lang=js&"
import style0 from "./AddReply.vue?vue&type=style&index=0&id=c55b4128&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports